
import Modal from '@/components/Shared/Modal/index.vue'
import FastLogin from '@/components/Contents/SeanceContent/FastLogin.vue'
import Purchase from '@/components/Contents/PurchaseAction/Purchase.vue'
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'
export default {
  components: {
    Modal,
    FastLogin,
    Purchase,
  },
  props: {
    item: {
      default: () => {},
    },
  },
  data() {
    return {
      noImage: false,
      showModal: false,
      showFastLogin: false,
      showPayments: false,
      boxes: ['Info', 'JoinLink', 'EventVideo'],
      activeBox: null,
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
      getUserIP: 'user/getUserIP',
      getSettings: 'getSettings',
    }),
    eventIsExpired() {
      const start = this.$date.getTimeWithoutOffset(this.item.date)
      if (!Number.isFinite(start)) return false
      const end = start + this.item.duration * 60000
      return end < Date.now()
    },
  },
  methods: {
    Currency(p) {
      return Currency(p, this.getUserIP.currency)
    },
    IS_FREE(price, discount) {
      const discountedPrice = (price * discount) / 100
      if (price - discountedPrice === 0) return true
      else false
    },
    LOGIN_SUCCESS() {
      this.showFastLogin = false
      this.showPayments = true
    },
    JOIN_EVENT() {
      this.showModal = false
      if (!this.getActiveUser.token) return (this.showFastLogin = true)
      else this.showPayments = true
    },
    showDetail(id) {
      if (id !== this.item.eventItemId) return
      this.showModal = true
    },
    getEventTimestamp() {
      const ts = this.$date.getTimeWithoutOffset(this.item.date)
      return Number.isFinite(ts) ? ts : null
    },
    SET_END_DATE() {
      const start = this.getEventTimestamp()
      if (start === null) return ''
      const end = start + this.item.duration * 60000
      return this.$date.formatOnlyTime(end)
    },
    GET_DATE() {
      const start = this.getEventTimestamp()
      if (start === null) return ''
      return new Date(start).getDate()
    },
    GET_FULLYEAR() {
      const start = this.getEventTimestamp()
      if (start === null) return ''
      return new Date(start).getFullYear()
    },
    GET_MONTH() {
      const start = this.getEventTimestamp()
      if (start === null) return ''
      const date = new Date(start)
      if (!Number.isFinite(date.getTime())) return ''
      return date.toLocaleDateString(this.$i18n.locale, { month: 'short' })
    },
  },
}
